// Per-route <title> setter. Each page calls this so users with many
// open tabs can tell pages apart, and so screen readers announce the
// page on navigation.
//
// The portal name (branding) is the suffix; the page name is the
// prefix. Example: "Dashboard — TicketWhip".

import { useEffect } from "react";
import { useBranding } from "./branding";

export function useDocumentTitle(pageTitle: string | null | undefined): void {
  const branding = useBranding();
  useEffect(() => {
    if (!pageTitle) {
      document.title = branding.portalName;
      return;
    }
    document.title = `${pageTitle} — ${branding.portalName}`;
  }, [pageTitle, branding.portalName]);
}
